import { getToken } from './getToken';

export async function fetchWithToken<T>(url: string, params?: RequestInit): Promise<T> {
  const { token, cookie } = await getToken();

  const headers: HeadersInit = {
    'X-RequestVerificationToken': token,
    Cookie: cookie,
    ...params?.headers,
  };

  const response = await fetch(url, {
    ...params,
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<T>;
}
